var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FilespacesKeyFactory, usePlugFilespaceClient } from '#query-hooks';
export const useSetAccessSettings = ({ filespaceId, workspaceId }, { onError, onSuccess }) => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const mutation = useMutation({
        mutationFn: async ({ settingName, settingValue, }) => plugFilespaceClient({
            action: (fsClient) => fsClient
                .generalSettingsManager()
                .setSettings({ [settingName]: settingValue }),
            filespaceId,
            workspaceId,
        }),
        onSuccess: async () => {
            try {
                await queryClient.refetchQueries({
                    exact: true,
                    queryKey: FilespacesKeyFactory.exact(workspaceId, filespaceId),
                });
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useSetAccessSettings, "o0s1hYhUCjAbRTTY8BWLnVP5U/c=", false, () => [useQueryClient, usePlugFilespaceClient, useMutation]);
